import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import BrandsSection from '../Section/BrandsSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import AppointmentSection from '../Section/AppointmentSection';
import DepartmentSection from '../Section/DepartmentSection';
import WhyWorkWithUsSection from '../Section/WhyWorkWithUsSection';
import { pageTitle } from '../../helpers/PageTitle';
const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Mission',
    subTitle:
      'Our goal is to support dental professionals by providing precise, innovative, and reliable digital orthodontic solutions that enhance treatment efficiency and improve patient outcomes. We are committed to working collaboratively to meet the needs of the dental community.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Vision',
    subTitle:
      'Through our visionary approach, we seek to transform the treatment experience for practitioners and patients alike, making high-quality orthodontic care accessible and efficient for everyone.',
  },
  {
    iconSrc: '/images/home_1/respect.svg',
    title: 'Innovation & Technology',
    subTitle:
      'We continuously embrace the latest CAD/CAM technologies and digital workflows to deliver smarter, faster, and more precise orthodontic solutions. Our commitment to innovation helps our clients stay ahead in an evolving digital dentistry landscape.',
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Precision & Integrity',
    subTitle: `Every design we create is built on accuracy, transparency, and professional ethics. We maintain the highest quality standards while protecting client data and ensuring every orthodontic solution meets clinical expectations with complete reliability.`,
  },
  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Collaborative Partnership',
    subTitle:
      'We work closely with orthodontists, dental laboratories, and aligner manufacturers to understand their unique requirements and deliver customized digital solutions. Through strong collaboration and responsive support, we help improve efficiency and treatment outcomes.',
  },
];
const brandData = [
  { imgUrl: 'images/brand_1.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_2.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_3.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_4.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_5.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_6.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_7.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_8.png', imgAlt: 'Brand' },
];
const departmentData = [
  {
    title: 'Clear Aligner Treatment Planning',
    iconUrl: 'images/home_1/department_icon_1.svg',
    href: '/services/clear-aligner-treatment-planning',
  },
  {
    title: 'Orthodontic CAD Design Services',
    iconUrl: 'images/home_1/department_icon_2.svg',
    href: '/services/orthodontic-cad-design-services',
  },
  {
    title: 'Fixed and Removable Retainer Design',
    iconUrl: 'images/home_1/department_icon_3.svg',
    href: '/services/fixed-and-removable-retainer-design',
  },
  {
    title: 'Sleep Apnea & MAD Device Design',
    iconUrl: 'images/home_1/department_icon_4.svg',
    href: '/services/sleep-apnea-mad-device-design',
  },
  {
    title: 'Surgical Guide Design for Implantology',
    iconUrl: 'images/home_1/department_icon_5.svg',
    href: '/services/surgical-guide-design-for-implantology',
  },
  {
    title: 'Digital Model Analysis and Setup',
    iconUrl: 'images/home_1/department_icon_6.svg',
    href: '/services/digital-model-analysis-and-setup',
  },
  //  {
  //   title: '3D Orthodontic Treatment Simulation',
  //   iconUrl: 'images/home_1/department_icon_7.svg',
  //   href: '/services/3d-orthodontic-treatment-simulation',
  // },
   {
    title: 'CAD/CAM Workflow Consultation',
    iconUrl: 'images/home_1/department_icon_8.svg',
    href: '/services/cad-cam-workflow-consultation',
  },
  //  {
  //   title: 'CAD/CAM Workflow Consultation',
  //   iconUrl: 'images/home_1/department_icon_6.svg',
  //   href: '/services/department-details',
  // },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="Precision in Design. Excellence in Orthodontics."
        subTitle="Precision-engineered digital orthodontic CAD solutions for faster workflows, exceptional accuracy, and consistent treatment outcomes."
        bgUrl="/images/banner.mp4"
        videoBtnText="See how it works"
        videoUrl="/gallery"
        infoList={[
          {
            title: 'Hotline',
            subTitle: '+91 9988220981',
            iconUrl: '/images/contact/icon_1.svg',
            type:"phone"
          },
          // {
          //   title: 'Ambulance',
          //   subTitle: '876-256-876',
          //   iconUrl: '/images/icons/ambulance.svg',
          // },
          {
            title: 'Location',
            subTitle: 'Maharashtra, India.',
            iconUrl: '/images/icons/pin.svg',
            tupe:"text"
          },
        ]}
        btnText="Book Now"
        btnUrl="/contact"
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection sectionTitle="Our Values" data={featureListData} />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.png"
          title="About Us"
          subTitle="Precision Digital Orthodontic Solutions for Modern Orthodontic Practices"
          featureList={[
            {
              featureListTitle:
                '',
              featureListSubTitle:
                'Precision Ortho CAD excels in digital orthodontic design, delivering top-tier CAD services to orthodontists, dental laboratories, and aligner manufacturers worldwide. With our cutting-edge workflows and unmatched engineering precision, we provide accurate, efficient, and reliable orthodontic solutions that set the standard in the industry.',
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Services"
          bgUrl="images/home_1/department_bg.svg"
          data={departmentData}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Award Section */}
      {/* <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Departments" data={awardData} />
      </Section> */}
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section topMd={185} topLg={140} topXl={100}>
        <WhyWorkWithUsSection sectionTitle="Why Work With Us" />
      </Section>
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle="Some Reviews"
          sectionTitleDown="Of our clients"
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/cta_img.png"
          title="Don’t Let Your Smile Take a Backseat!"
          subTitle="Schedule a case with our experienced dental professionals today!"
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          data={blogData}
        />
      </Section> */}
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Case"
          sectionTitleUp="BOOK Your"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section> */}
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      <Section
        topMd={100}
        topLg={50}
        topXl={10}
        bottomMd={100}
        bottomLg={50}
        bottomXl={10}
      >
        <BrandsSection data={brandData} />
      </Section>
      {/* End Brand Section */}
    </>
  );
}
